// Comprehensive Driving & Motoring Clubs Database - Northeast US
// Last updated: February 2026 - Verified links and comprehensive coverage

export const CLUB_TYPES = [
  { id: 'all', label: 'All Clubs' },
  { id: 'touring', label: 'Touring & Drives' },
  { id: 'concours', label: 'Concours & Shows' },
  { id: 'track', label: 'Track & HPDE' },
  { id: 'marque', label: 'Marque-Specific' },
  { id: 'social', label: 'Social & Coffee' },
  { id: 'vintage', label: 'Vintage & Classic' },
  { id: 'rally', label: 'Rally' },
  { id: 'autocross', label: 'Autocross' }
]

export const CLUB_FOCUSES = [
  'All Makes',
  'Porsche',
  'Ferrari',
  'BMW',
  'Audi',
  'Mercedes-Benz',
  'Jaguar',
  'Corvette',
  'British Cars',
  'Lotus',
  'Italian Cars',
  'German Cars',
  'Japanese Cars',
  'American Muscle',
  'Vintage/Pre-War',
  'Modern Supercars',
  'Land Rover'
]

export const DRIVING_CLUBS = [
  // ============================================
  // PORSCHE CLUB OF AMERICA - ZONE 1 CHAPTERS
  // ============================================
  {
    id: 'pca-metro-ny',
    name: 'Metro NY Region PCA',
    type: 'marque',
    focus: ['Porsche', 'German Cars'],
    description: 'One of PCA\'s founding regions, serving NYC and Long Island since 1958. Comprehensive activities from autocross to concours with 4,600+ members.',
    vibe: 'The quintessential Porsche club experience with 65+ years of heritage. Mix of serious drivers and social enthusiasts.',
    membershipType: 'Open to all Porsche owners',
    membershipCost: '$46/year (national PCA dues)',
    region: 'New York City & Long Island',
    events: 'Autocross, club racing, concours, driver education, rallies, tech sessions',
    website: 'https://metronypca.org/',
    instagram: '@metronypca',
    members: '4,600+ members',
    verified: true,
    featured: true,
    idealFor: 'NYC-area Porsche owners wanting the full club experience'
  },
  {
    id: 'pca-cvr',
    name: 'Connecticut Valley Region PCA',
    type: 'marque',
    focus: ['Porsche', 'German Cars'],
    description: 'Serving Connecticut since 1959 with one of PCA\'s best autocross programs. Active driver education at Lime Rock Park.',
    vibe: 'Performance-oriented with strong track day culture. Friendly and welcoming to newcomers.',
    membershipType: 'Open to all Porsche owners',
    membershipCost: '$46/year (national PCA dues)',
    region: 'Connecticut',
    events: 'Autocross, driver education at Lime Rock, concours, social events',
    website: 'https://cvrpca.org/',
    instagram: '@cvr_pca',
    members: '3,600+ members',
    verified: true,
    featured: true,
    idealFor: 'Connecticut Porsche owners, especially those interested in autocross and track days'
  },
  {
    id: 'pca-ner',
    name: 'Northeast Region PCA',
    type: 'marque',
    focus: ['Porsche', 'German Cars'],
    description: 'Massachusetts and Rhode Island chapter with comprehensive programming from driver education to wine tours. Concours at The Elms during Audrain Motor Week.',
    vibe: 'Well-organized with something for everyone. Strong emphasis on both driving and social events.',
    membershipType: 'Open to all Porsche owners',
    membershipCost: '$46/year (national PCA dues)',
    region: 'Massachusetts & Rhode Island',
    events: 'DE at NHMS/Palmer, autocross at Devens, concours at The Elms, tours, tech sessions',
    website: 'https://porschenet.com/',
    members: '3,000+ members',
    verified: true,
    featured: false,
    idealFor: 'New England Porsche owners seeking variety of activities'
  },
  {
    id: 'pca-hudson-valley',
    name: 'Hudson Valley Region PCA',
    type: 'marque',
    focus: ['Porsche', 'German Cars'],
    description: 'Scenic touring through the Hudson Valley with social events and technical workshops. Based in Pine Bush, NY.',
    vibe: 'Relaxed touring focus with emphasis on enjoying beautiful Hudson Valley roads.',
    membershipType: 'Open to all Porsche owners',
    membershipCost: '$46/year (national PCA dues)',
    region: 'Hudson Valley, NY (Dutchess, Orange, Putnam, Rockland, Sullivan, Ulster)',
    events: 'Scenic tours, social events, technical workshops',
    website: 'https://hv.pca.org/',
    members: '800+ members',
    verified: true,
    featured: true,
    idealFor: 'Hudson Valley Porsche owners who enjoy scenic drives and socializing'
  },
  {
    id: 'pca-jersey-shore',
    name: 'Jersey Shore Region PCA',
    type: 'marque',
    focus: ['Porsche', 'German Cars'],
    description: 'Serving Monmouth and Ocean counties since 1960. Active driver education program at NJMP.',
    vibe: 'Track-oriented with strong social component. Regular events at New Jersey Motorsports Park.',
    membershipType: 'Open to all Porsche owners',
    membershipCost: '$46/year (national PCA dues)',
    region: 'Jersey Shore (Monmouth, Ocean counties)',
    events: 'Driver education at NJMP, social events, tours',
    website: 'https://www.jsrpca.com/',
    instagram: '@jerseyshoreporscheclub',
    members: '1,200+ members',
    verified: true,
    featured: false,
    idealFor: 'Shore-area Porsche owners wanting track time at NJMP'
  },
  {
    id: 'pca-nnjr',
    name: 'Northern New Jersey Region PCA',
    type: 'marque',
    focus: ['Porsche', 'German Cars'],
    description: 'Active chapter with comprehensive driver education and social programs. Hosts New Hope Auto Show and Concours.',
    vibe: 'Welcoming community with focus on driver development and car appreciation.',
    membershipType: 'Open to all Porsche owners',
    membershipCost: '$46/year (national PCA dues)',
    region: 'Northern New Jersey',
    events: 'Driver education, New Hope Auto Show, autocross, new member gatherings',
    website: 'https://nnjr-pca.com/',
    members: '2,000+ members',
    verified: true,
    featured: false,
    idealFor: 'North Jersey Porsche owners'
  },
  {
    id: 'pca-cny',
    name: 'Central New York Region PCA',
    type: 'marque',
    focus: ['Porsche', 'German Cars'],
    description: 'Covering Central New York with autocross, HPDE, concours, club racing, driving tours, and tech sessions.',
    vibe: 'All-around club covering every aspect of Porsche ownership.',
    membershipType: 'Open to all Porsche owners',
    membershipCost: '$46/year (national PCA dues)',
    region: 'Central New York',
    events: 'Autocross, HPDE, concours, club racing, tours',
    website: 'https://cnypca.org/',
    members: '700+ members',
    verified: true,
    featured: false,
    idealFor: 'Central NY Porsche owners'
  },
  {
    id: 'pca-finger-lakes',
    name: 'Finger Lakes Region PCA',
    type: 'marque',
    focus: ['Porsche', 'German Cars'],
    description: 'Scenic tours through New York\'s beautiful Finger Lakes wine country. Social and dining events.',
    vibe: 'Touring and social focus in one of NY\'s most beautiful regions.',
    membershipType: 'Open to all Porsche owners',
    membershipCost: '$46/year (national PCA dues)',
    region: 'Finger Lakes, NY',
    events: 'Tours, dining events, car shows',
    website: 'https://flk.pca.org/',
    members: '500+ members',
    verified: true,
    featured: false,
    idealFor: 'Finger Lakes Porsche owners'
  },
  {
    id: 'pca-down-east',
    name: 'Down East Region PCA',
    type: 'marque',
    focus: ['Porsche', 'German Cars'],
    description: 'Maine\'s Porsche club featuring scenic drives and Porsches & Coffee events. Porsches in the Park benefits the Dempsey Center.',
    vibe: 'Smaller, tight-knit community in Maine with charity focus.',
    membershipType: 'Open to all Porsche owners',
    membershipCost: '$46/year (national PCA dues)',
    region: 'Maine',
    events: 'Driving events, Porsches & Coffee, tech seminars, Porsches in the Park',
    website: 'https://www.derpca.com/',
    members: '400+ members',
    verified: true,
    featured: false,
    idealFor: 'Maine Porsche owners'
  },

  // ============================================
  // FERRARI CLUB OF AMERICA
  // ============================================
  {
    id: 'fca-empire-state',
    name: 'Ferrari Club of America - Empire State Region',
    type: 'marque',
    focus: ['Ferrari', 'Italian Cars'],
    description: 'New York\'s premier Ferrari club with chapters in Hudson Valley, Long Island, and Upstate. Events range from casual dinners to track days.',
    vibe: 'Passionate Ferrari community. Mix of concours purists and driving enthusiasts. Welcoming despite the exclusive marque.',
    membershipType: 'FCA membership required, open to Ferrari owners and enthusiasts',
    membershipCost: '$100/year (national FCA dues)',
    region: 'New York State',
    events: 'Track days, concours, social dinners, tours, tech sessions',
    website: 'https://empirestateregion.ferrariclubofamerica.us/',
    instagram: '@ferrariclubofamerica_esr',
    members: '500+ members',
    verified: true,
    featured: true,
    idealFor: 'Ferrari owners and serious enthusiasts in New York'
  },

  // ============================================
  // BMW CAR CLUB OF AMERICA
  // ============================================
  {
    id: 'bmwcca-boston',
    name: 'BMW CCA Boston Chapter',
    type: 'marque',
    focus: ['BMW', 'German Cars'],
    description: 'One of BMW CCA\'s most active chapters with comprehensive HPDE, autocross, karting, and concours programs. Annual concours in July.',
    vibe: 'Performance-focused but inclusive. Strong track day culture with excellent instruction.',
    membershipType: 'Open to all BMW owners and enthusiasts',
    membershipCost: '$48/year (national BMW CCA dues)',
    region: 'Massachusetts & Rhode Island',
    events: 'HPDE at NHMS/Palmer, autocross, karting, concours (July 27, 2025), tech sessions',
    website: 'https://boston-bmwcca.org/',
    members: '3,500+ members',
    verified: true,
    featured: true,
    idealFor: 'New England BMW owners, especially those interested in performance driving'
  },
  {
    id: 'bmwcca-ny',
    name: 'BMW CCA New York Chapter',
    type: 'marque',
    focus: ['BMW', 'German Cars'],
    description: 'Serving the NYC metro area with social events, beach parties, vineyard tours, and high performance driving schools.',
    vibe: 'Social and diverse programming. Mix of casual enthusiasts and serious drivers.',
    membershipType: 'Open to all BMW owners and enthusiasts',
    membershipCost: '$48/year (national BMW CCA dues)',
    region: 'New York City Metro (Nassau County)',
    events: 'Beach parties, vineyard tours, concours, autocross, HPDE',
    website: 'https://www.bmwcca.org/chapter/new-york-chapter',
    members: '2,500+ members',
    verified: true,
    featured: false,
    idealFor: 'NYC-area BMW owners seeking social and driving events'
  },

  // ============================================
  // AUDI CLUB NORTH AMERICA
  // ============================================
  {
    id: 'audi-neq',
    name: 'Audi Club Northeast Quattro (NEQ)',
    type: 'marque',
    focus: ['Audi', 'German Cars'],
    description: 'Northeast chapter featuring winter driving schools, HPDE at Lime Rock, Watkins Glen, NJMP, and Mont Tremblant. Karting events in Wallingford, CT.',
    vibe: 'Quattro-focused performance driving. Particularly strong winter driving program.',
    membershipType: 'Open to all Audi owners and enthusiasts',
    membershipCost: '$60/year',
    region: 'NY, CT, VT',
    events: 'Winter driving schools, HPDE, karting, tech sessions, rallies',
    website: 'https://www.neqclub.org/',
    members: '800+ members',
    verified: true,
    featured: false,
    idealFor: 'Audi enthusiasts wanting to explore their quattro systems'
  },

  // ============================================
  // CORVETTE CLUBS
  // ============================================
  {
    id: 'corvette-ct',
    name: 'Club Corvette of Connecticut',
    type: 'marque',
    focus: ['Corvette', 'American Muscle'],
    description: 'Connecticut\'s premier Corvette club since 1993 with cruises, events, trips, and an annual Corvette show. 300+ members.',
    vibe: 'Friendly, family-oriented Corvette community. Active social calendar.',
    membershipType: 'Open to all Corvette owners',
    membershipCost: '$35/year',
    region: 'Connecticut',
    events: 'Cruises, annual Corvette show, trips, social events',
    website: 'https://www.clubcorvettect.com/',
    instagram: '@clubcorvettect',
    members: '300+ members',
    verified: true,
    featured: false,
    idealFor: 'Connecticut Corvette owners seeking social events and cruises'
  },
  {
    id: 'corvette-dv',
    name: 'Corvette Club of Delaware Valley',
    type: 'marque',
    focus: ['Corvette', 'American Muscle'],
    description: 'Active Philadelphia-area Corvette club based in Willow Grove, PA with shows, cruises, and social events.',
    vibe: 'Community-focused with emphasis on enjoying your Corvette.',
    membershipType: 'Open to all Corvette owners',
    membershipCost: '$40/year',
    region: 'Delaware Valley (PA/NJ)',
    events: 'Car shows, cruises, social events',
    website: 'https://www.ccdv.com/',
    members: '200+ members',
    verified: true,
    featured: false,
    idealFor: 'Delaware Valley Corvette owners'
  },
  {
    id: 'corvette-nepa',
    name: 'Corvette Club of Northeastern Pennsylvania',
    type: 'marque',
    focus: ['Corvette', 'American Muscle'],
    description: 'Scranton-area Corvette club established 1967. Shows, touring, and social events.',
    vibe: 'Traditional Corvette club atmosphere.',
    membershipType: 'Open to all Corvette owners',
    membershipCost: '$35/year',
    region: 'Northeastern PA (Scranton area)',
    events: 'Shows, tours, social events',
    website: 'https://ccnepa.ernccc.org/',
    members: '150+ members',
    verified: true,
    featured: false,
    idealFor: 'NEPA Corvette owners'
  },
  {
    id: 'corvette-central-pa',
    name: 'Central PA Corvette Club',
    type: 'marque',
    focus: ['Corvette', 'American Muscle'],
    description: 'Greater Harrisburg area club since 1971. Shows, tours, and camaraderie.',
    vibe: 'Established club with decades of Corvette heritage.',
    membershipType: 'Open to all Corvette owners',
    membershipCost: '$35/year',
    region: 'Central Pennsylvania (Harrisburg)',
    events: 'Shows, tours, social events',
    website: 'https://www.centralpacorvetteclub.com/',
    members: '200+ members',
    verified: true,
    featured: false,
    idealFor: 'Central PA Corvette owners'
  },

  // ============================================
  // MERCEDES-BENZ CLUBS
  // ============================================
  {
    id: 'mbca-nyc-li',
    name: 'Mercedes-Benz Club - NYC/Long Island Section',
    type: 'marque',
    focus: ['Mercedes-Benz', 'German Cars'],
    description: 'Active section of the national MBCA since 1952 with tech sessions, detailing workshops, and scenic drives. Based at Gullwing Motors in Mineola.',
    vibe: 'Knowledgeable enthusiasts who appreciate Mercedes heritage and craftsmanship.',
    membershipType: 'Open to Mercedes-Benz owners and enthusiasts',
    membershipCost: '$55/year (national MBCA dues)',
    region: 'NYC & Long Island',
    events: 'Tech sessions, detailing workshops, drives, social events',
    website: 'https://mbcany.org/',
    members: '450+ members',
    verified: true,
    featured: false,
    idealFor: 'Mercedes-Benz owners in the NYC/Long Island area'
  },

  // ============================================
  // JAGUAR CLUBS
  // ============================================
  {
    id: 'jaguar-dv',
    name: 'Delaware Valley Jaguar Club',
    type: 'marque',
    focus: ['Jaguar', 'British Cars'],
    description: 'Established 1965, serving Eastern PA, South Jersey, Delaware, and Eastern Maryland. 200+ members with JCNA-sanctioned events.',
    vibe: 'Traditional Jaguar club with appreciation for heritage and proper driving.',
    membershipType: 'Open to Jaguar owners and enthusiasts',
    membershipCost: '$75/year',
    region: 'Delaware Valley (PA/NJ/DE/MD)',
    events: 'Concours, slalom, rally, car shows, social events',
    website: 'https://delvaljaguarclub.com/',
    instagram: '@delaware_valley_jaguar_club',
    members: '200+ members',
    verified: true,
    featured: false,
    idealFor: 'Jaguar owners in the Delaware Valley region'
  },
  {
    id: 'jaguar-jtc',
    name: 'Jaguar Touring Club (NJ)',
    type: 'marque',
    focus: ['Jaguar', 'British Cars'],
    description: 'Philosophy: "Jaguars are meant to be driven." Covers NJ, NY, CT, PA with emphasis on enjoying your car, not just polishing it.',
    vibe: 'Driving-focused rather than concours-focused. Appreciates all Jaguars from vintage to modern.',
    membershipType: 'Open to Jaguar owners',
    membershipCost: '$50/year',
    region: 'NJ, NY, CT, PA',
    events: 'Car shows, touring events, JCNA-sanctioned events',
    website: 'https://jtc-nj.net/',
    members: '150+ members',
    verified: true,
    featured: false,
    idealFor: 'Jaguar owners who actually drive their cars'
  },

  // ============================================
  // BRITISH CAR CLUBS
  // ============================================
  {
    id: 'bmcne',
    name: 'British Motorcars of New England',
    type: 'marque',
    focus: ['British Cars', 'Vintage/Pre-War'],
    description: 'Dedicated to preservation and enjoyment of British automobiles throughout New England since the 1960s.',
    vibe: 'Classic British car appreciation with technical knowledge sharing.',
    membershipType: 'Open to British car owners and enthusiasts',
    membershipCost: '$35/year',
    region: 'New England (MA, RI, CT, VT, NH, ME)',
    events: 'Shows, tours, technical events',
    website: 'https://bmcne.org/',
    members: '400+ members',
    verified: true,
    featured: false,
    idealFor: 'Owners of MG, Triumph, Austin-Healey, Jaguar, and other British marques'
  },
  {
    id: 'mgcc-li',
    name: 'MG Car Club - Long Island Centre',
    type: 'marque',
    focus: ['British Cars'],
    description: 'Long Island chapter for MG and British sports car enthusiasts. Monthly meetings at The Old Fields Inn, Greenlawn.',
    vibe: 'Friendly, knowledgeable MG community.',
    membershipType: 'Open to MG owners and enthusiasts',
    membershipCost: '$30/year',
    region: 'Long Island, NY',
    events: 'Car shows, rallying, concours, autocross, tech sessions (2nd Friday monthly)',
    members: '100+ members',
    verified: true,
    featured: false,
    idealFor: 'MG owners on Long Island'
  },
  {
    id: 'british-nepa',
    name: 'British Car Clubs of Northeastern Pennsylvania',
    type: 'marque',
    focus: ['British Cars'],
    description: 'Multi-marque British car club serving NEPA region.',
    vibe: 'Welcoming to all British car makes.',
    membershipType: 'Open to British car owners',
    membershipCost: '$25/year',
    region: 'Northeastern Pennsylvania',
    events: 'Shows, tours, tech sessions',
    website: 'http://www.bccnepa.com/',
    members: '75+ members',
    verified: true,
    featured: false,
    idealFor: 'NEPA British car owners'
  },

  // ============================================
  // LOTUS CLUBS
  // ============================================
  {
    id: 'lotus-loony',
    name: 'Lotus Owners of New York (LOONY)',
    type: 'marque',
    focus: ['Lotus', 'British Cars'],
    description: 'Western and Central NY Lotus enthusiasts covering Buffalo, Rochester, Syracuse, and Watkins Glen area.',
    vibe: 'Small, dedicated Lotus community enjoying lightweight British sports cars.',
    membershipType: 'Open to Lotus owners',
    membershipCost: '$30/year',
    region: 'Western/Central NY',
    events: 'Meetups, drives, track days at Watkins Glen',
    members: '50+ members',
    verified: true,
    featured: false,
    idealFor: 'Lotus owners in Upstate NY'
  },
  {
    id: 'lotus-ct',
    name: 'Lotus Club of Connecticut',
    type: 'marque',
    focus: ['Lotus', 'British Cars'],
    description: 'Connecticut Lotus enthusiasts based in Westport area.',
    vibe: 'Intimate club for Lotus appreciation.',
    membershipType: 'Open to Lotus owners',
    membershipCost: '$25/year',
    region: 'Connecticut',
    events: 'Meetups, drives',
    members: '30+ members',
    verified: true,
    featured: false,
    idealFor: 'Connecticut Lotus owners'
  },

  // ============================================
  // VINTAGE & CLASSIC CAR CLUBS
  // ============================================
  {
    id: 'vscca',
    name: 'Vintage Sports Car Club of America',
    type: 'vintage',
    focus: ['Vintage/Pre-War', 'All Makes'],
    description: 'America\'s oldest automotive preservation club (est. 1958). Wheel-to-wheel vintage racing, rallies, and hillclimbs. 2,000+ members.',
    vibe: 'Serious vintage racing with strong camaraderie. Cars must be authentic period-correct.',
    membershipType: 'Open to owners of pre-1966 sports cars',
    membershipCost: '$75/year',
    region: 'Northeast-focused (national)',
    events: 'Vintage racing at Lime Rock, rallies, hillclimbs, social events',
    website: 'https://www.vscca.org/',
    members: '2,000+ members',
    verified: true,
    featured: true,
    idealFor: 'Owners of pre-1966 sports cars who want to race authentically'
  },
  {
    id: 'ccca',
    name: 'Classic Car Club of America',
    type: 'vintage',
    focus: ['Vintage/Pre-War'],
    description: 'Dedicated to fine and unusual vehicles from 1915-1948. Grand Classic car shows and CARavans. Long Island Sound Region covers Northeast.',
    vibe: 'Traditional, established club for serious collectors of classic era automobiles.',
    membershipType: 'Open to owners of CCCA-recognized Classic cars',
    membershipCost: '$80/year',
    region: 'National (Long Island Sound Region)',
    events: 'Grand Classic shows, CARavans, technical events',
    website: 'https://www.classiccarclub.org/',
    members: '5,000+ national',
    verified: true,
    featured: false,
    idealFor: 'Collectors of significant pre-war and classic era automobiles'
  },
  {
    id: 'aaca',
    name: 'Antique Automobile Club of America',
    type: 'vintage',
    focus: ['Vintage/Pre-War', 'All Makes'],
    description: 'One of America\'s largest car clubs with 350+ chapters. Focus on vehicles 25+ years old. Seminars, forums, publications.',
    vibe: 'Inclusive community for all antique and classic vehicle enthusiasts.',
    membershipType: 'Open to all antique vehicle enthusiasts',
    membershipCost: '$45/year',
    region: 'National (many Northeast chapters)',
    events: 'Shows, seminars, forums, automotive archive library',
    website: 'https://aaca.org/',
    members: '50,000+ national',
    verified: true,
    featured: false,
    idealFor: 'Owners of vehicles 25+ years old'
  },
  {
    id: 'vmcca',
    name: 'Vintage Motor Car Club of America',
    type: 'vintage',
    focus: ['Vintage/Pre-War'],
    description: 'Dedicated to acquisition, preservation, exhibition of vintage vehicles.',
    vibe: 'Preservation-focused enthusiasts.',
    membershipType: 'Open to vintage car enthusiasts',
    membershipCost: '$50/year',
    region: 'National',
    events: 'Tours, exhibitions, social events',
    website: 'https://vmcca.org/',
    members: '3,000+ national',
    verified: true,
    featured: false,
    idealFor: 'Vintage vehicle collectors'
  },

  // ============================================
  // RALLY CLUBS
  // ============================================
  {
    id: 'rally-north-america',
    name: 'Rally North America',
    type: 'rally',
    focus: ['All Makes', 'Modern Supercars'],
    description: 'Charity rally organization with automotive scavenger hunt tours. Raised $2.4M+ for Hope for the Warriors, Concerns of Police Survivors, Camp Sunshine.',
    vibe: 'Fun, adventure-focused rallies with a charitable mission. Not competitive racing.',
    membershipType: 'Event registration open to all',
    membershipCost: 'Per-event registration',
    region: 'Northeast & National',
    events: 'Charity rally tours throughout the year',
    website: 'https://rallynorthamerica.com/',
    members: 'Raised $2.4M+',
    verified: true,
    featured: true,
    idealFor: 'Those seeking adventure rallies with a charitable purpose'
  },
  {
    id: 'ner-scca',
    name: 'New England Region SCCA',
    type: 'rally',
    focus: ['All Makes'],
    description: 'Official SCCA chapter with GTA road rallies, RallyCross, Solo autocross, and time trials at Devens.',
    vibe: 'Competitive but welcoming. Good introduction to performance motorsports.',
    membershipType: 'SCCA membership required',
    membershipCost: '$99/year (SCCA national)',
    region: 'New England',
    events: 'Road rallies, RallyCross, autocross at Devens, track events',
    website: 'https://ner.org/',
    members: '2,500+ members',
    verified: true,
    featured: false,
    idealFor: 'Those interested in competitive rally and autocross'
  },
  {
    id: 'nnjr-scca',
    name: 'Northern New Jersey Region SCCA',
    type: 'autocross',
    focus: ['All Makes'],
    description: 'Active SCCA chapter with year-round autocross at MetLife Stadium and spring Time-Speed-Distance rallies.',
    vibe: 'Competitive autocross community with all skill levels welcome.',
    membershipType: 'SCCA membership (weekend memberships available)',
    membershipCost: '$99/year or weekend membership',
    region: 'Northern New Jersey',
    events: 'Autocross at MetLife Stadium, TSD rallies',
    website: 'https://scca-nnjr.com/',
    members: '1,500+ members',
    verified: true,
    featured: false,
    idealFor: 'Those wanting competitive autocross near NYC'
  },
  {
    id: 'nerc',
    name: 'North East Rally Club',
    type: 'rally',
    focus: ['All Makes'],
    description: 'Road rally events including the annual Pumpkin Run. Based in Delaware area.',
    vibe: 'Traditional road rally club.',
    membershipType: 'Open membership',
    membershipCost: '$35/year',
    region: 'Delaware/Northeast',
    events: 'Pumpkin Run, road rallies',
    website: 'https://www.northeastrallyclub.com/',
    members: '100+ members',
    verified: true,
    featured: false,
    idealFor: 'Road rally enthusiasts'
  },

  // ============================================
  // TRACK DAY ORGANIZATIONS
  // ============================================
  {
    id: 'nasa-ne',
    name: 'NASA Northeast',
    type: 'track',
    focus: ['All Makes'],
    description: '45+ years of HPDE and racing at Watkins Glen, Lime Rock, NJMP Lightning/Thunderbolt, and Pocono. Clear progression from novice to racer.',
    vibe: 'Serious driver development with clear progression path from novice to competition license.',
    membershipType: 'Open to all (NASA membership for racing)',
    membershipCost: '$69/year membership',
    region: 'Northeast',
    events: 'HPDE, competition school, time trials, racing',
    website: 'https://nasane.com/',
    instagram: '@nasa_ne',
    members: '5,000+ participants',
    verified: true,
    featured: true,
    idealFor: 'Drivers wanting to progress from track days to racing'
  },
  {
    id: 'scda',
    name: 'Sports Car Driving Association (SCDA)',
    type: 'track',
    focus: ['All Makes'],
    description: 'Strictly educational, non-competitive track days since 1995. Events at Lime Rock, Watkins Glen, NJMP, Palmer, Thompson, Club Motorsports, NHMS.',
    vibe: 'Educational focus, no timing, no pressure. Best introduction to the track.',
    membershipType: 'Open to all (no membership required)',
    membershipCost: '$449-599 per track day',
    region: 'Northeast',
    events: '2025 Lime Rock: 3/22, 4/21, 5/12, 6/12, 7/15, 8/9, 9/8, 10/13, 10/24-25, 11/8',
    website: 'https://scda1.com/',
    members: 'Thousands of participants',
    verified: true,
    featured: true,
    idealFor: 'First-time track day participants and those wanting stress-free track time'
  },
  {
    id: 'hooked-driving',
    name: 'Hooked on Driving',
    type: 'track',
    focus: ['All Makes'],
    description: 'National track day organization with events at NJMP Lightning and Watkins Glen International.',
    vibe: 'Fun, accessible track days for all experience levels.',
    membershipType: 'Open to all',
    membershipCost: 'Per-event registration',
    region: 'Northeast (NJMP, Watkins Glen)',
    events: 'Track days at multiple Northeast venues',
    website: 'https://www.hookedondriving.com/',
    verified: true,
    featured: false,
    idealFor: 'Track day enthusiasts seeking variety'
  },
  {
    id: 'svra',
    name: 'Sportscar Vintage Racing Association',
    type: 'vintage',
    focus: ['Vintage/Pre-War', 'All Makes'],
    description: 'Vintage racing at Lime Rock Historic Festival, Watkins Glen SpeedTour with Grand Prix Festival street reenactment.',
    vibe: 'Authentic vintage racing with proper period-correct vehicles.',
    membershipType: 'Competition license required for racing',
    membershipCost: 'Entry fees vary',
    region: 'Northeast events',
    events: 'Historic Festival at Lime Rock, Watkins Glen SpeedTour (Sept 4-7, 2025)',
    website: 'https://svra.com/',
    verified: true,
    featured: false,
    idealFor: 'Those wanting to race vintage cars authentically'
  },

  // ============================================
  // CARS & COFFEE / SOCIAL CLUBS
  // ============================================
  {
    id: 'caffeine-carbs',
    name: 'Caffeine & Carburetors',
    type: 'social',
    focus: ['All Makes'],
    description: 'New Canaan\'s premier gathering at Zumbach\'s. Sundays 8-11 AM. No jury, all welcome, free admission.',
    vibe: 'Casual, welcoming atmosphere. Some of the most interesting cars in the Northeast show up.',
    membershipType: 'Free, open to all',
    membershipCost: 'Free',
    region: 'New Canaan, CT',
    events: 'Sunday mornings, 8-11 AM',
    website: 'https://caffeineandcarburetors.com/',
    members: '500+ cars typical',
    verified: true,
    featured: true,
    idealFor: 'Anyone wanting to see amazing cars on a Sunday morning'
  },
  {
    id: 'cars-coffee-darien',
    name: 'Cars and Coffee Darien',
    type: 'social',
    focus: ['All Makes'],
    description: 'Second Sunday of the month, April-November at Old Mill Center. Family-friendly with monthly manufacturer features.',
    vibe: 'Family-friendly suburban gathering with monthly manufacturer spotlights.',
    membershipType: 'Free, open to all',
    membershipCost: 'Free',
    region: 'Darien, CT',
    events: 'Second Sunday, April-November',
    website: 'https://carsandcoffeedarien.com/',
    verified: true,
    featured: false,
    idealFor: 'Families and casual enthusiasts in Fairfield County'
  },
  {
    id: 'westchester-cc',
    name: 'Westchester Cars & Coffee',
    type: 'social',
    focus: ['All Makes'],
    description: 'Running since 2012 in Peekskill, welcoming all cars from gearheads to novices. Diversity welcome.',
    vibe: 'Inclusive, diverse crowd. Everything from restored classics to modern exotics.',
    membershipType: 'Free, open to all',
    membershipCost: 'Free',
    region: 'Peekskill, NY',
    events: 'Regular meetups',
    website: 'https://westchestercarsandcoffee.com/',
    verified: true,
    featured: false,
    idealFor: 'Westchester car enthusiasts'
  },
  {
    id: 'greenwich-cc',
    name: 'Greenwich Cars & Coffee',
    type: 'social',
    focus: ['All Makes'],
    description: 'Periodic gatherings in Greenwich, CT throughout the year.',
    vibe: 'Premium location, high-quality cars.',
    membershipType: 'Free, open to all',
    membershipCost: 'Free',
    region: 'Greenwich, CT',
    events: 'Periodic throughout year',
    website: 'http://www.greenwichcarsandcoffee.com/',
    verified: true,
    featured: false,
    idealFor: 'Greenwich-area enthusiasts'
  },
  {
    id: 'audrain-cc',
    name: 'Audrain Auto Museum Cars & Coffee',
    type: 'social',
    focus: ['All Makes'],
    description: 'Monthly gatherings at the prestigious Audrain Auto Museum in Newport. 350-400 cars typical, 1000+ at Motor Week.',
    vibe: 'High-quality gathering at a world-class automotive museum.',
    membershipType: 'Registration required (members first)',
    membershipCost: 'Museum membership or event fee',
    region: 'Newport, RI',
    events: 'Monthly April-November',
    website: 'https://www.audrainautomuseum.org/cars-and-coffee-2025',
    members: '1,000+ at special events',
    verified: true,
    featured: true,
    idealFor: 'Those wanting a premium Cars & Coffee experience'
  },
  {
    id: 'bedford-cc',
    name: 'Bedford Cars & Coffee',
    type: 'social',
    focus: ['All Makes'],
    description: 'Massachusetts gatherings at Craft Food Halls. Season opener to closer events May-October.',
    vibe: 'Family-friendly, diverse vehicles welcome.',
    membershipType: 'Free, open to all',
    membershipCost: 'Free',
    region: 'Burlington/Lexington, MA',
    events: 'May 4 opener, June 22, July 20, Aug 17, Sept 21, Oct 19 closer',
    website: 'https://www.bedfordmacars.com/events',
    verified: true,
    featured: false,
    idealFor: 'Massachusetts car enthusiasts north of Boston'
  },
  {
    id: 'rochester-cc',
    name: 'Rochester Cars & Coffee',
    type: 'social',
    focus: ['All Makes'],
    description: 'Monthly gatherings at The Little Speed Shop in Rochester, NY. 10+ years of community.',
    vibe: 'Local, friendly, long-established.',
    membershipType: 'Free, open to all',
    membershipCost: 'Free',
    region: 'Rochester, NY',
    events: 'Monthly, Saturdays 8-10 AM',
    verified: true,
    featured: false,
    idealFor: 'Rochester car enthusiasts'
  },
  {
    id: 'classic-car-club-manhattan',
    name: 'Classic Car Club Manhattan',
    type: 'social',
    focus: ['All Makes', 'Vintage/Pre-War', 'Modern Supercars'],
    description: 'NYC-based club with fleet of shared classics and supercars. Clubhouse in Tribeca with events, drives, and networking.',
    vibe: 'Urban car enthusiasts who may not have garage space. Social scene meets car culture.',
    membershipType: 'Tiered Membership',
    membershipCost: '$3,500-$30,000/year',
    region: 'New York City',
    events: 'Weekly drives, monthly parties',
    website: 'https://www.classiccarclub.com/',
    instagram: '@classiccarclubmanhattan',
    members: '1,000+ members',
    verified: true,
    featured: true,
    idealFor: 'NYC residents who want access to cars and community without full ownership'
  },

  // ============================================
  // CONCOURS ORGANIZATIONS
  // ============================================
  {
    id: 'greenwich-concours',
    name: 'Greenwich Concours d\'Elegance',
    type: 'concours',
    focus: ['All Makes', 'Vintage/Pre-War'],
    description: 'One of the top automotive events in the Northeast at Roger Sherman Baldwin Park. Memorial Day Weekend annually.',
    vibe: 'Premier concours event with serious collector cars and knowledgeable crowds.',
    membershipType: 'Ticket purchase or vehicle entry',
    membershipCost: 'Ticket prices vary',
    region: 'Greenwich, CT',
    events: 'May 30 - June 1, 2025',
    website: 'https://www.greenwichconcours.com/',
    verified: true,
    featured: true,
    idealFor: 'Serious collectors and those appreciating the finest automobiles'
  },
  {
    id: 'audrain-concours',
    name: 'Audrain Newport Concours & Motor Week',
    type: 'concours',
    focus: ['All Makes', 'Vintage/Pre-War'],
    description: 'Named International Motoring Event of the Year 2025. Four days at The Breakers including 50-Mile Supercar Drive, auctions, Concours.',
    vibe: 'Prestigious, world-class concours rivaling Pebble Beach.',
    membershipType: 'Ticket purchase',
    membershipCost: 'Various tiers',
    region: 'Newport, RI',
    events: 'October 1-4, 2026',
    website: 'https://www.audrainconcours.com/',
    instagram: '@audrainconcours',
    verified: true,
    featured: true,
    idealFor: 'Collectors and enthusiasts seeking a world-class concours experience'
  },
  {
    id: 'great-marques',
    name: 'Great Marques Concours d\'Elegance',
    type: 'concours',
    focus: ['All Makes'],
    description: 'Long Island\'s premier car club concours at Morgan Memorial Park, Glen Cove. Features Ferrari, Mercedes, BMW clubs.',
    vibe: 'Club-organized concours with accessible judging and friendly atmosphere.',
    membershipType: 'Event registration',
    membershipCost: 'Entry fees vary',
    region: 'Glen Cove, Long Island, NY',
    events: 'September 28, 2025',
    website: 'https://greatmarques.org/',
    instagram: '@greatmarques',
    verified: true,
    featured: false,
    idealFor: 'Long Island collectors wanting club-level concours experience'
  },
  {
    id: 'radnor-hunt',
    name: 'Radnor Hunt Concours d\'Elegance',
    type: 'concours',
    focus: ['All Makes', 'Vintage/Pre-War'],
    description: 'Only US concours featuring coaches and carriages alongside classics. 29th annual in 2026.',
    vibe: 'Unique blend of automotive and equestrian heritage.',
    membershipType: 'Ticket purchase',
    membershipCost: 'Various tiers',
    region: 'Radnor, PA',
    events: 'September 11-13, 2026',
    website: 'https://radnorconcours.org/',
    verified: true,
    featured: false,
    idealFor: 'Those appreciating the intersection of automotive and equestrian culture'
  },

  // ============================================
  // EXCLUSIVE / PRIVATE CLUBS
  // ============================================
  {
    id: 'lime-rock-drivers-club',
    name: 'Lime Rock Drivers Club',
    type: 'track',
    focus: ['All Makes'],
    description: 'Private membership club at legendary Lime Rock Park. Track days, storage, and exclusive access to America\'s most scenic race track.',
    vibe: 'Serious drivers who want regular track time in a proper setting.',
    membershipType: 'Full Membership',
    membershipCost: '$15,000-$50,000 initiation + annual dues',
    region: 'Lakeville, CT',
    events: '20+ private track days per year',
    website: 'https://limerock.com/',
    members: '250+ members',
    verified: true,
    featured: true,
    idealFor: 'Track enthusiasts who want quality seat time without the hassle'
  },

  // ============================================
  // CONNECTICUT - NEW ENTRIES
  // ============================================
  {
    id: 'scda-ct',
    name: 'SCDA (Sports Car Driving Association)',
    type: 'track',
    focus: ['All Makes'],
    description: 'Founded 1995, SCDA offers educational HPDE events at Thompson & Lime Rock tracks. Non-competitive, instruction-focused track days.',
    vibe: 'Educational track day experience focused on driver development without competition pressure.',
    membershipType: 'Open to all',
    membershipCost: '$449-599 per event',
    region: 'Northeast',
    events: 'HPDE at Thompson & Lime Rock throughout the season',
    website: 'https://scda1.com/',
    verified: true,
    featured: false,
    idealFor: 'Track day enthusiasts seeking educational HPDE experiences'
  },
  {
    id: 'ct-shoreline-cc',
    name: 'CT Shoreline Cars and Coffee',
    type: 'social',
    focus: ['All Makes'],
    description: 'Bi-weekly casual meetup with a judgment-free zone atmosphere. All makes and models welcome.',
    vibe: 'Relaxed, inclusive social gatherings for car enthusiasts.',
    membershipType: 'Free, open to all',
    membershipCost: 'Free',
    region: 'Connecticut Shoreline',
    events: 'Bi-weekly casual meetups',
    website: 'https://ctshorelinecarsandcoffee.com/',
    verified: true,
    featured: false,
    idealFor: 'Connecticut shoreline car enthusiasts seeking casual meets'
  },
  {
    id: 'corvette-ct-limited',
    name: 'Corvettes Limited of Connecticut',
    type: 'marque',
    focus: ['Corvette', 'American Muscle'],
    description: 'Dedicated Connecticut Corvette club for enthusiasts and owners.',
    vibe: 'Passionate Corvette community.',
    membershipType: 'Open to Corvette owners and enthusiasts',
    membershipCost: 'Varies',
    region: 'Connecticut',
    events: 'Club meetings and events',
    website: 'https://corvetteslimitedofct.com/',
    verified: true,
    featured: false,
    idealFor: 'Connecticut Corvette owners'
  },

  // ============================================
  // MASSACHUSETTS - NEW ENTRIES
  // ============================================
  {
    id: 'palmer-motorsports',
    name: 'Palmer Motorsports Club',
    type: 'track',
    focus: ['All Makes'],
    description: 'Massachusetts\' first true road course with a 2.5-mile track. 100+ operating days per season for HPDE and track events.',
    vibe: 'Premier track day venue with excellent facilities and instructors.',
    membershipType: 'Application required',
    membershipCost: 'Application required',
    region: 'Western Massachusetts',
    events: '100+ track days per season',
    website: 'https://palmermsp.com/',
    verified: true,
    featured: true,
    idealFor: 'New England drivers seeking frequent track day access'
  },
  {
    id: 'larz-anderson-cc',
    name: 'Cars & Coffee at Larz Anderson',
    type: 'social',
    focus: ['All Makes'],
    description: 'Free monthly gatherings at the beautiful 64-acre Larz Anderson Park in Boston area. Concours-style presentation.',
    vibe: 'Premium free Cars & Coffee experience at a historic estate.',
    membershipType: 'Free, open to all',
    membershipCost: 'Free',
    region: 'Boston area',
    events: 'Monthly events',
    website: 'https://larzanderson.org/',
    verified: true,
    featured: false,
    idealFor: 'Boston-area car enthusiasts seeking quality free gatherings'
  },
  {
    id: 'bedford-ma-cc',
    name: 'Bedford MA Cars & Coffee',
    type: 'social',
    focus: ['All Makes'],
    description: 'Family-friendly monthly meets held May through October at Craft Food Halls in Lexington/Bedford area.',
    vibe: 'Seasonal family-friendly car meetups with diverse vehicles.',
    membershipType: 'Free, open to all',
    membershipCost: 'Free',
    region: 'Lexington/Bedford MA',
    events: 'Monthly May-October',
    website: 'https://bedfordmacars.com/',
    verified: true,
    featured: false,
    idealFor: 'Massachusetts families interested in casual car gatherings'
  },
  {
    id: 'vscca-ma',
    name: 'VSCCA (Vintage Sports Car Club of America)',
    type: 'vintage',
    focus: ['Vintage/Pre-War', 'All Makes'],
    description: 'Vintage racing, hill climbs, and tours for pre-1980s vintage sports cars. 2,000+ members across New England.',
    vibe: 'Authentic vintage racing community with strong tradition.',
    membershipType: 'Open to vintage sports car owners',
    membershipCost: '$100/year',
    region: 'New England',
    events: 'Vintage racing, hill climbs, tours',
    website: 'https://vscca.org/',
    members: '2,000+ members',
    verified: true,
    featured: false,
    idealFor: 'Vintage sports car owners interested in authentic racing'
  },

  // ============================================
  // MAINE - NEW ENTRIES
  // ============================================
  {
    id: 'down-east-pca',
    name: 'Down East Region PCA',
    type: 'marque',
    focus: ['Porsche', 'German Cars'],
    description: 'Maine\'s Porsche club with 400+ members. Known for Porsches in the Park charity event benefiting local causes.',
    vibe: 'Community-focused Porsche club with charitable mission.',
    membershipType: 'Open to all Porsche owners',
    membershipCost: 'PCA membership required',
    region: 'Maine',
    events: 'Porsches in the Park charity event, driving events, tech sessions',
    website: 'https://derpca.com/',
    members: '400+ members',
    verified: true,
    featured: false,
    idealFor: 'Maine Porsche owners'
  },
  {
    id: 'mid-maine-scc',
    name: 'Mid Maine Sports Car Club',
    type: 'vintage',
    focus: ['British Cars', 'European Cars'],
    description: '300+ members dedicated to British and European sports cars. Active in rallies, tours, and hosts the Camden Car Show.',
    vibe: 'Community-focused club with emphasis on drives and events.',
    membershipType: 'Open to British and European car owners',
    membershipCost: 'Varies',
    region: 'Mid-Coast Maine',
    events: 'Rallies, tours, Camden Car Show',
    website: 'https://mmscc.com/',
    members: '300+ members',
    verified: true,
    featured: false,
    idealFor: 'Mid-coast Maine owners of British and European cars'
  },

  // ============================================
  // NEW HAMPSHIRE - NEW ENTRIES
  // ============================================
  {
    id: 'club-motorsports-nh',
    name: 'Club Motorsports',
    type: 'track',
    focus: ['All Makes'],
    description: 'Premier 2.5-mile track nestled in the White Mountains. 40+ operating days per season for HPDE and track events.',
    vibe: 'World-class track day facility with scenic location and excellent amenities.',
    membershipType: 'Membership-based',
    membershipCost: '$15,000 initiation + $1,500/year',
    region: 'White Mountains NH',
    events: '40+ track days per season',
    website: 'https://clubmotorsports.com/',
    verified: true,
    featured: true,
    idealFor: 'Serious track enthusiasts wanting frequent quality track time'
  },
  {
    id: 'british-cars-nh',
    name: 'British Cars of New Hampshire',
    type: 'marque',
    focus: ['British Cars'],
    description: '27+ years of operation serving British car enthusiasts. Monthly meetings and hosts the Show of Dreams charity event.',
    vibe: 'Established British car community with charitable mission.',
    membershipType: 'Open to British car owners',
    membershipCost: 'Varies',
    region: 'New Hampshire',
    events: 'Monthly meetings, Show of Dreams charity event',
    website: 'https://bcnh.org/',
    verified: true,
    featured: false,
    idealFor: 'New Hampshire British car owners'
  },
  {
    id: 'team-oneil-rally',
    name: 'Team O\'Neil Rally School',
    type: 'rally',
    focus: ['All Makes'],
    description: 'Professional rally driving school and competition events in New Hampshire.',
    vibe: 'Professional-level rally instruction and competition.',
    membershipType: 'Event and course registration',
    membershipCost: 'Per-event and per-course fees',
    region: 'New Hampshire',
    events: 'Rally school courses and competition events',
    website: 'https://teamoneil.com/',
    verified: true,
    featured: false,
    idealFor: 'Those wanting professional rally instruction and competition'
  },

  // ============================================
  // NEW JERSEY - NEW ENTRIES
  // ============================================
  {
    id: 'jaguar-jtc-nj',
    name: 'Jaguar Touring Club NJ',
    type: 'marque',
    focus: ['Jaguar', 'British Cars'],
    description: 'Large informal group affiliated with JCNA. Philosophy: "Jaguars are meant to be driven." Regular Cars & Croissants events.',
    vibe: 'Driving-focused Jaguar community that appreciates all eras.',
    membershipType: 'Open to Jaguar owners',
    membershipCost: '$30/year',
    region: 'NJ/NY/CT/PA',
    events: 'Cars & Croissants, touring drives, JCNA-sanctioned events',
    website: 'https://jtc-nj.net/',
    verified: true,
    featured: false,
    idealFor: 'Jaguar owners who actually drive their cars'
  },
  {
    id: 'cars-coffee-nj',
    name: 'Cars & Coffee NJ',
    type: 'social',
    focus: ['All Makes'],
    description: 'Monthly gatherings on the last Sunday at Millstone Township. Free, open to all.',
    vibe: 'Casual, inclusive Cars & Coffee experience.',
    membershipType: 'Free, open to all',
    membershipCost: 'Free',
    region: 'Central New Jersey',
    events: 'Last Sunday of each month',
    website: 'https://carsandcoffeenj.com/',
    verified: true,
    featured: false,
    idealFor: 'Central New Jersey car enthusiasts'
  },

  // ============================================
  // NEW YORK - NEW ENTRIES
  // ============================================
  {
    id: 'cnyca',
    name: 'Central NY Car Club Association',
    type: 'social',
    focus: ['All Makes'],
    description: 'Umbrella organization connecting 55+ car clubs across central New York.',
    vibe: 'Networking hub for central New York car club community.',
    membershipType: 'Varies (umbrella organization)',
    membershipCost: 'Varies',
    region: 'Central New York',
    events: 'Connects multiple club events',
    website: 'https://cnycca.org/',
    verified: true,
    featured: false,
    idealFor: 'Central NY car clubs and enthusiasts'
  },
  {
    id: 'cny-scca',
    name: 'CNY Region SCCA',
    type: 'rally',
    focus: ['All Makes'],
    description: 'Road rally and RallyCross events in central New York.',
    vibe: 'Competitive rally community.',
    membershipType: 'SCCA membership required',
    membershipCost: 'SCCA membership',
    region: 'Central New York',
    events: 'Road rallies, RallyCross',
    website: 'https://cny-scca.com/',
    verified: true,
    featured: false,
    idealFor: 'Rally and RallyCross enthusiasts in central NY'
  },
  {
    id: 'mohawk-hudson-scca',
    name: 'Mohawk-Hudson SCCA',
    type: 'rally',
    focus: ['All Makes'],
    description: 'Rally and RallyCross events in the Albany area and Capital District.',
    vibe: 'Competitive rally community in upstate New York.',
    membershipType: 'SCCA membership required',
    membershipCost: 'SCCA membership',
    region: 'Capital District NY',
    events: 'Rally and RallyCross events',
    website: 'https://mohud-scca.org/',
    verified: true,
    featured: false,
    idealFor: 'Albany-area rally enthusiasts'
  },
  {
    id: 'upstate-ny-cc',
    name: 'Upstate NY Car Club',
    type: 'social',
    focus: ['All Makes'],
    description: 'Based in Ithaca with events including cruises, car shows, and track events.',
    vibe: 'Community-focused upstate New York car club.',
    membershipType: 'Open to all',
    membershipCost: 'Free',
    region: 'Upstate New York',
    events: 'Cruises, shows, track events',
    website: 'https://upstatenycarclub.com/',
    verified: true,
    featured: false,
    idealFor: 'Ithaca and upstate New York car enthusiasts'
  },

  // ============================================
  // RHODE ISLAND - NEW ENTRIES
  // ============================================
  {
    id: 'audrain-concours-ri',
    name: 'Audrain Newport Concours',
    type: 'concours',
    focus: ['All Makes'],
    description: 'Prestigious annual concours event. Audrain museum membership provides access.',
    vibe: 'World-class concours experience at legendary Audrain museum.',
    membershipType: 'Ticket purchase or museum membership',
    membershipCost: 'Membership varies',
    region: 'Newport RI',
    events: 'Annual Audrain Newport Concours',
    website: 'https://audrainconcours.com/',
    verified: true,
    featured: true,
    idealFor: 'Collectors seeking world-class concours experiences'
  },
  {
    id: 'corvette-ri',
    name: 'Corvette Club of Rhode Island',
    type: 'marque',
    focus: ['Corvette', 'American Muscle'],
    description: 'Founded 1964 with 200+ members. Active charitable organization supporting local causes.',
    vibe: 'Established Corvette community with charitable mission.',
    membershipType: 'Open to Corvette owners',
    membershipCost: 'Varies',
    region: 'Rhode Island',
    events: 'Charitable events, shows, cruises',
    website: 'https://corvetteclubofrhodeisland.com/',
    members: '200+ members',
    verified: true,
    featured: false,
    idealFor: 'Rhode Island Corvette owners'
  },
  {
    id: 'bmcne-ri',
    name: 'British Motorcars of New England',
    type: 'marque',
    focus: ['British Cars'],
    description: 'Operating since 1984, offering tech sessions and garage tours for British car enthusiasts.',
    vibe: 'Technical focus on British car preservation and maintenance.',
    membershipType: 'Open to British car owners',
    membershipCost: 'Varies',
    region: 'Rhode Island/New England',
    events: 'Tech sessions, garage tours, shows',
    website: 'https://bmcne.org/',
    verified: true,
    featured: false,
    idealFor: 'British car owners interested in technical knowledge'
  },

  // ============================================
  // VERMONT - NEW ENTRIES
  // ============================================
  {
    id: 'green-mountain-pca',
    name: 'Green Mountain Region PCA',
    type: 'marque',
    focus: ['Porsche', 'German Cars'],
    description: 'Vermont\'s Porsche club with 210+ members. Organized driving tours and technical sessions.',
    vibe: 'Scenic New England Porsche community.',
    membershipType: 'Open to all Porsche owners',
    membershipCost: 'PCA membership required',
    region: 'Vermont',
    events: 'Driving tours, tech sessions',
    website: 'https://gmtpca.org/',
    members: '210+ members',
    verified: true,
    featured: false,
    idealFor: 'Vermont Porsche owners'
  },
  {
    id: 'sccv',
    name: 'Sports Car Club of Vermont',
    type: 'autocross',
    focus: ['All Makes'],
    description: 'Autocross, hillclimb, ice time trials, and rallies for all skill levels.',
    vibe: 'Diverse motorsport activities for Vermont enthusiasts.',
    membershipType: 'Open to all',
    membershipCost: 'Per-event fees',
    region: 'Vermont',
    events: 'Autocross, hillclimbs, ice time trials, rallies',
    website: 'https://sccv.org/',
    verified: true,
    featured: false,
    idealFor: 'Vermont motorsport enthusiasts'
  },
  {
    id: 'vt-auto-enthusiasts',
    name: 'Vermont Automobile Enthusiasts',
    type: 'vintage',
    focus: ['Vintage/Pre-War', 'All Makes'],
    description: 'Founded 1953, featuring 12 monthly meets and 2 car shows. Known for the annual Antique Meet in Waterbury.',
    vibe: 'Long-established vintage car community with strong tradition.',
    membershipType: 'Open to vintage car owners',
    membershipCost: 'Varies',
    region: 'Vermont',
    events: '12 monthly meets, 2 annual car shows, Annual Antique Meet in Waterbury',
    website: 'https://vtauto.org/',
    verified: true,
    featured: false,
    idealFor: 'Vermont vintage and classic car owners'
  },

  // ============================================
  // REGIONAL - NEW ENTRIES
  // ============================================
  {
    id: 'ner-scca-regional',
    name: 'New England Region SCCA',
    type: 'rally',
    focus: ['All Makes'],
    description: 'One of the largest SCCA regions offering monthly RallyCross events and other motorsport activities.',
    vibe: 'Major New England motorsport hub.',
    membershipType: 'SCCA membership required',
    membershipCost: 'SCCA membership',
    region: 'New England',
    events: 'Monthly RallyCross, rallies, autocross',
    website: 'https://ner.org/',
    verified: true,
    featured: false,
    idealFor: 'New England rally and motorsport enthusiasts'
  },
  {
    id: 'alfa-owners-ne',
    name: 'Alfa Owners of New England',
    type: 'marque',
    focus: ['Alfa Romeo', 'Italian Cars'],
    description: 'AROC affiliated club serving Massachusetts and northern New England Alfa Romeo enthusiasts.',
    vibe: 'Community for passionate Alfa Romeo owners.',
    membershipType: 'AROC membership',
    membershipCost: 'AROC membership',
    region: 'New England',
    events: 'Club events, drives, shows',
    website: 'https://velocissima.com/',
    verified: true,
    featured: false,
    idealFor: 'Alfa Romeo owners in New England'
  }
]

// Helper functions
export function getClubsByType(type) {
  if (type === 'all') return DRIVING_CLUBS
  return DRIVING_CLUBS.filter(club => club.type === type)
}

export function getClubsByFocus(focus) {
  if (focus === 'All Makes') return DRIVING_CLUBS
  return DRIVING_CLUBS.filter(club => club.focus.includes(focus))
}

export function getFeaturedClubs() {
  return DRIVING_CLUBS.filter(club => club.featured)
}

export function searchClubs(query) {
  const q = query.toLowerCase()
  return DRIVING_CLUBS.filter(club =>
    club.name.toLowerCase().includes(q) ||
    club.description.toLowerCase().includes(q) ||
    club.focus.some(f => f.toLowerCase().includes(q)) ||
    club.region.toLowerCase().includes(q)
  )
}
